import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateTuitionOptionsMutation = graphql.persisted(
  "UpdateTuitionOptions",
  graphql(`
    mutation UpdateTuitionOptions($input: UpdateTuitionOptionsInput!) {
      updateTuitionOptions(input: $input) {
        schoolYear {
          id
          tuitionOptionsSetting {
            description
            items {
              key
              name
              costCents
              description
            }
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateTuitionOptionsMutation };

export function useUpdateTuitionOptions() {
  return useMutation(UpdateTuitionOptionsMutation);
}
